import { useLocation } from 'react-router-dom';

export default function PaymentResult(props: any) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extrae todos los parámetros en un objeto para mostrarlos
    const params = Object.fromEntries(queryParams.entries());

    return (
        <div className='content'>
            <h1>Payment Result</h1>

            {Object.entries(params).map(([key, value]) => (
                <p key={key}>
                    <strong>{key}:</strong> {value}
                </p>
            ))}
        </div>
    );
}
